import { useState } from "react";
import { PlusCircle, History, Loader2 } from "lucide-react";
import "../css/adai.css";
import AdaiForm from "../components/AdaiForm.jsx";
import ResultDisplay from "../components/ResultDisplay.jsx";
import HistoryTab from "../components/HistoryTab.jsx";

const TABS = [
  { key: "generate", label: "Generate", icon: PlusCircle },
  { key: "history",  label: "History",  icon: History },
];

const GeneratingState = () => (
  <div className="w-full bg-white! rounded-4xl border border-slate-100 p-12! mt-6! flex flex-col items-center text-center">
    <div className="w-16 h-16 bg-blue-50! rounded-2xl flex items-center justify-center mb-5!">
      <Loader2 className="text-blue-500! animate-spin" size={32} />
    </div>
    <h3 className="text-xl font-bold text-slate-800 m-0! mb-2!">
      Generating Documentation
    </h3>
    <p className="text-sm text-slate-400 m-0! max-w-md">
      Fetching work items and code diffs, then building your release documentation…
    </p>
    <div className="mt-8! w-full max-w-md flex flex-col gap-3! items-center">
      <div className="h-3 bg-slate-100! rounded-full animate-pulse w-3/4" />
      <div className="h-3 bg-slate-100! rounded-full animate-pulse w-1/2" />
      <div className="h-3 bg-slate-100! rounded-full animate-pulse w-5/6" />
      <div className="h-3 bg-slate-100! rounded-full animate-pulse w-2/3" />
      <div className="h-3 bg-slate-100! rounded-full animate-pulse w-3/5" />
    </div>
  </div>
);

const AdaiPage = () => {
  const [result, setResult]             = useState(null);
  const [isGenerating, setIsGenerating] = useState(false);
  const [apiError, setApiError]         = useState("");
  const [activeTab, setActiveTab]       = useState("generate");

  const handleGenerationStart = () => {
    setIsGenerating(true);
    setResult(null);
  };

  const handleGenerationEnd = (hasError) => {
    setIsGenerating(false);
    if (hasError) setResult(null);
  };

  return (
    <div className="min-h-screen bg-[#f6f8fb]! p-6! w-full! flex flex-col items-center">
      <div className="w-full max-w-350! m-2!">
        {/* Header */}
        <header className="mb-5! text-left! w-full!">
          <h2 className="text-xl font-extrabold text-slate-900 m-0! text-left!">
            ADAI (Advanced Documentation AI)
          </h2>
          <p className="text-sm mt-2! font-medium text-slate-400!">
            Advanced Documentation AI for generating release notes from your
            selected Version Control Platform's code and Project Lifecycle
            Platform's work items.
          </p>
        </header>

        {/* Tab Nav */}
        <nav className="flex items-center border-gray-200 rounded-t-xl border-b mb-5!">
          {TABS.map((tab) => {
            const Icon = tab.icon;
            return (
              <div
                key={tab.key}
                onClick={() => setActiveTab(tab.key)}
                className={[
                  "inline-flex items-center gap-1.5 px-4 py-3.5",
                  "text-sm border-b-2 -mb-px whitespace-nowrap",
                  "transition-colors duration-150 bg-transparent border-0 cursor-pointer",
                  activeTab === tab.key
                    ? "border-b-2 border-slate-900 text-slate-900 font-semibold"
                    : "border-transparent text-slate-500 font-medium hover:text-slate-900",
                ].join(" ")}
              >
                <Icon size={15} />
                {tab.label}
              </div>
            );
          })}
        </nav>

        {/* Generate Tab */}
        {activeTab === "generate" && (
          <>
            <AdaiForm
              onResult={setResult}
              onGenerationStart={handleGenerationStart}
              onGenerationEnd={handleGenerationEnd}
              apiError={apiError}
              setApiError={setApiError}
            />
            {isGenerating && !result && <GeneratingState />}
            {result && <ResultDisplay result={result} />}
          </>
        )}

        {/* History Tab */}
        {activeTab === "history" && (
          <HistoryTab onNewGeneration={() => setActiveTab("generate")} />
        )}
      </div>
    </div>
  );
};

export default AdaiPage;
